<template>
  <v-container grid-list-sm text-xs-left mt-4>
    <v-layout row wrap justify-left fill-height>
      <v-flex xs12>
        <v-card :class="{ 'rounded': !isMobile() }">
          <v-layout
              row
              wrap
              pa-2
          >
            <v-flex xs12 md4>
              <v-subheader
                  :key="titleHeader"
                  class="subheading"
              >
                {{ titleHeader }}
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4 class="pa-3">
              <v-checkbox
                  v-model="toBeEvaluatedCheckbox"
                  label="To Be Evaluated"
                  color="orange"
                  hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="pa-3">
              <v-checkbox
                  v-model="rejectedCheckbox"
                  label="Rejected"
                  color="red"
                  hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="pa-3">
              <v-checkbox
                  v-model="approvedCheckbox"
                  label="Approved"
                  color="green"
                  hide-details
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-list>
            <template v-for="(element, index) in filteredItems">
              <v-divider
                  v-if="element.divider"
                  :inset="element.inset"
              />
              <v-list-tile class="clickable-cursor"
                           v-else
                           :key="element.id"
              >
                <v-layout row wrap>
                  <v-flex xs7 sm8 md8 lg8>
                    <v-list-tile-content @click="clickCallback(element)">
                      <v-list-tile-title class="element-height">Proposal of
                        <v-chip :color="colorChip(element.operation)" label outline>{{ element.operation }}</v-chip>
                        by <strong>{{ element.author }}</strong> for startup <strong>{{ element.startup.Name }}</strong>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-flex>
                  <v-flex sm2 md2 lg2 v-if="!isMobile()">
                    <span>Proposal date:</span>
                    <br>
                    <span>{{ formatDate(element.date) }}</span>
                  </v-flex>
                  <v-flex xs5 sm2 md2 lg2 class="text-xs-right">
                    <v-chip dark :color="colorChip(element.status)">{{ element.status }}</v-chip>
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </template>
          </v-list>

        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="openDialog"
        :max-width="selectedOperation.operation === 'UPDATE' || selectedOperation.operation === 'UPDATE_STARTUP'? 1100 : 600"
        persistent
        scrollable
    >
      <v-card>
        <v-card-title class="headline">
          <span class="headline">Operation of {{ selectedOperation.operation }}</span>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card-title>

        <v-card-text v-if="startupNotAvailable">
          <v-layout row wrap>
            <v-flex xs6>
              Startup no longer available
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-card-text
            v-else-if="selectedOperation.operation === 'UPDATE' || selectedOperation.operation === 'UPDATE_STARTUP'">


          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap mx-3>
                <v-spacer></v-spacer>
                <v-flex xs4 pb-2 class="text-xs-center">
                  <strong style="font-size: 18px">Currently saved in Discovery</strong>
                </v-flex>
                <v-flex xs4 pb-2 class="text-xs-center">
                  <strong style="font-size: 18px">Proposed changes</strong>
                </v-flex>
              </v-layout>

              <v-flex style="border: solid 1px" v-if="key !=='_id' && key !== 'token'" v-for="value, key in nowStartup"
                      :class="isDifferent(key,selectedOperation.startup[key]) ? 'showDifference' : ''">
                <v-layout row wrap mx-3>
                  <v-flex xs4 style="border-right: solid 1px">
                    <strong style="font-size: 15px">{{ key }}</strong>
                  </v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <span v-if="key ==='approved'" style="word-break: break-all; font-size: 15px">{{
                        value ? 'APPROVED' : 'NOT APPROVED'
                      }}</span>
                    <span v-else style="word-break: break-all; font-size: 15px">{{ value }}</span>
                  </v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <span v-if="key ==='approved'" style="word-break: break-all; font-size: 15px">{{
                        selectedOperation.startup[key] ? 'APPROVED' : 'NOT APPROVED'
                      }}</span>
                    <span v-else
                          style="word-break: break-all; font-size: 15px">{{
                        isDifferent(key, selectedOperation.startup[key]) ? selectedOperation.startup[key] : value
                      }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>

          </v-layout>


        </v-card-text>
        <v-card-text v-else>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex style="border: solid 1px" v-if="key !=='_id' && key !== 'token'"
                      v-for="value, key in selectedOperation.startup">
                <v-layout row wrap mx-3>
                  <v-flex grow>
                    <strong style="font-size: 15px">{{ key }}</strong>
                  </v-flex>
                  <v-flex shrink>
                    <span v-if="key ==='approved'" style="word-break: break-all; font-size: 15px">{{
                        value ? 'APPROVED' : 'NOT APPROVED'
                      }}</span>
                    <span v-else style="word-break: break-all; font-size: 15px">{{ value }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
        v-model="rejectStartupDialog"
        max-width="650"
        persistent
    >
      <v-card>
        <v-card-title class="headline">Are you sure to reject this operation?</v-card-title>
        <v-card-text>
          <v-textarea
              label="Reason for rejection (optional)"
              box
              rows="5"
              clearable
              clear-icon="mdi-close"
              auto-grow
              v-model="description">
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              flat="flat"
              @click="rejectStartupDialog=false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="red"
              flat="flat"
              @click="reject"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="duplicateName" max-width="450">
      <v-card>
        <v-card-title class="headline error white--text">Startup creation failed</v-card-title>
        <v-card-text>{{ startupErrorDescription }}</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";

export default {
  name: "OperationsHistory",
  components: {},
  data() {
    return {
      description: "",
      rejectStartupDialog: false,
      toBeEvaluatedCheckbox: true,
      rejectedCheckbox: false,
      approvedCheckbox: false,
      elements: [],
      titleHeader: "Operations history",
      openDialog: false,
      selectedOperation: {},
      nowStartup: {},
      updateStartup: {},
      startupNotAvailable: false,
      duplicateName: false,
      startupErrorDescription: ""
    };
  },
  computed: {
    filteredItems() {
      let filteredArray = [];
      for (let i = 0; i < this.elements.length; i = i + 2) {
        if ((this.toBeEvaluatedCheckbox && this.elements[i].status === "TO BE EVALUATED") ||
            (this.approvedCheckbox && this.elements[i].status === "APPROVED") ||
            (this.rejectedCheckbox && this.elements[i].status === "REJECTED")) {
          filteredArray.push(this.elements[i])
          filteredArray.push(this.elements[i + 1])
        }
      }
      filteredArray.pop();
      return filteredArray;
    }
  },
  created() {
    this.getOperations();
  },
  methods: {
    reject() {
      this.openDialog = false;
      this.rejectStartupDialog = false;
      this.approve(false);
    },
    arrayEquals(a, b) {
      return Array.isArray(a) &&
          Array.isArray(b) &&
          a.length === b.length &&
          a.every((val, index) => val === b[index]);
    },
    formatDate(date) {
      let formattedDate = new Date(date);
      formattedDate = formattedDate.getFullYear() + '-' + (formattedDate.getMonth() + 1) + '-' + formattedDate.getDate() + ' ' + formattedDate.getHours() + ':' + (formattedDate.getMinutes() < 10 ? '0' : '') + formattedDate.getMinutes();
      return formattedDate;
    },
    isDifferent(key, value) {
      if (this.selectedOperation.oldStartup !== undefined && this.selectedOperation.oldStartup[key] === value) {
        return false;
      } else if (this.selectedOperation.oldStartup !== undefined && this.arrayEquals(this.selectedOperation.oldStartup[key], value)) {
        return false;
      } else return true;
    },

    closeDialog() {
      this.selectedOperation = {};
      this.nowStartup = {};
      this.updateStartup = {};
      this.openDialog = false;
      this.startupNotAvailable = false;
      this.description = "";
    },
    colorChip(text) {
      if (text === "APPROVED" || text === "CREATE") return "green";
      else if (text === "REJECTED" || text === "DELETE") return "red";
      else return "orange";
    },
    getOperations() {
      this.elements = [];
      let requestUrl = {
        url: UrlsService.operationsHistory,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "GET",
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Get proposal operations",
        loading: "Waiting for operations...",
        error: "Cannot retrieve proposals...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let operations = responseSuccess.response.operations;
            for (let i = 0; i < operations.length; i++) {
              this.elements.push(operations[i]);
              if (i !== operations.length - 1) {
                this.elements.push({divider: true, inset: false,});
              }
            }
          });
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    getStartupById(id) {
      let startup = {
        _id: id
      }
      let requestUrl = {
        url: UrlsService.getStartupById,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          startupRequest: {
            startup: startup
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Get Startup",
        loading: "Waiting for the startup information...",
        error: "Cannot get the startup...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.openDialog = true;
            if (responseSuccess.response.startups[0] === null) {
              this.startupNotAvailable = true;
            } else {
              this.startupNotAvailable = false;
              if (this.selectedOperation.operation === "UPDATE" || this.selectedOperation.operation === "UPDATE_STARTUP") {
                this.nowStartup = responseSuccess.response.startups[0];
                for (let key in this.selectedOperation.oldStartup) {
                  if (this.selectedOperation.oldStartup !== undefined && this.selectedOperation.oldStartup[key] === this.selectedOperation.startup[key]) {
                    this.updateStartup[key] = this.nowStartup[key];
                  } else {
                    this.updateStartup[key] = this.selectedOperation.startup[key]
                  }
                }
                this.updateStartup["token"] = this.selectedOperation.startup["token"]
              } else if (this.selectedOperation.operation === "DELETE") {
                this.selectedOperation.startup = responseSuccess.response.startups[0];
              }
            }

          });
    },
    clickCallback(element) {
      if (element.status === "TO BE EVALUATED") {
        this.selectedOperation = element;
        if (element.operation === "UPDATE" || element.operation === "UPDATE_STARTUP" || element.operation === "DELETE") {
          this.getStartupById(this.selectedOperation.startup._id);
        } else {
          this.openDialog = true;
        }
      }


    },

  },
};
</script>

<style lang="scss" scoped>
.clickable-cursor {
  cursor: pointer;
}

.element-height {
  height: 40px;
}

.showDifference {
  background-color: yellow;
}

</style>
